import { useState } from 'react'
import { IsoField } from '../../models/IsoField'

export default function Iso8583Parser() {
  const [rawMessage, setRawMessage] = useState('')
  const [fields, setFields] = useState<IsoField[] | null>(null)
  const [error, setError] = useState('')

  const parseIsoMessage = (msg: string): IsoField[] | null => {
    if (!msg || msg.length < 10) return null

    const field = new IsoField()
    field.description = 'Sample'
    field.fieldId = 1
    field.fieldNumber = '001'
    field.value = msg.slice(0, 10)
    return [field]
  }

  const handleParse = () => {
    setError('')
    const result = parseIsoMessage(rawMessage)
    if (!result) {
      setFields(null)
      setError('Not able to parse the ISO 8583 message.')
    } else {
      setFields(result)
    }
  }

  return (
    <div className="min-h-screen p-2">
      <h2 className="mb-6 text-left text-2xl font-bold text-gray-900">
        ISO 8583 Field Parser
      </h2>

      <div className="space-y-2">
        <textarea
          value={rawMessage}
          onChange={(e) => setRawMessage(e.target.value)}
          placeholder="Paste raw ISO 8583 message here..."
          className="h-24 w-full rounded-xl border border-gray-300 bg-white p-4 font-mono text-gray-900 outline-none focus:ring-2 focus:ring-indigo-500"
        />

        <button
          onClick={handleParse}
          className="cursor-pointer rounded-xl bg-indigo-600 px-6 py-2 font-semibold text-white shadow transition hover:bg-indigo-700"
        >
          Parse
        </button>

        {error && <div className="mt-2 font-medium text-red-600">{error}</div>}

        {fields && (
          <div className="mt-2 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <div className="overflow-hidden rounded-lg shadow-sm outline outline-1 outline-black/5">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="w-48 py-2 pr-3 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                          Field
                        </th>
                        <th className="px-3 py-2 text-left text-sm font-semibold text-gray-900">
                          Value
                        </th>
                        <th className="px-3 py-2 text-left text-sm font-semibold text-gray-900">
                          Description
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {fields.map((field) => (
                        <tr key={field.fieldId}>
                          <td className="w-48 px-3 py-2 pr-3 pl-4 text-left text-sm font-mono font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                            {field.fieldNumber}
                          </td>
                          <td className="w-1/2 px-3 py-2 text-left text-sm font-mono whitespace-nowrap text-gray-500">
                            {field.value}
                          </td>
                          <td className="w-1/2 py-2 text-left text-sm whitespace-nowrap text-gray-500">
                            {field.description}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
